"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sanitizeInput = exports.sanitizeCustomInput = void 0;
var MAX_VALUE = 99999;
var DEFAULT_ITEMS = [3, 5, 10, 15, 20, 25, 50, 100].map(function (value) { return ({
    type: "option",
    value: value,
    label: "" + value,
}); });
var trimInput = function (input) { return input && input.trim(); };
var matchNumericValues = function (input) { return /^[^-\d]*(-?\d+)(?:\s|$)/.exec(input); };
var sanitizeNumericValue = function (value, intl) {
    if (value < 1) {
        return [{ type: "error", label: intl.formatMessage({ id: "rankingFilter.valueTooSmall" }) }];
    }
    else if (value > MAX_VALUE) {
        return [{ type: "error", label: intl.formatMessage({ id: "rankingFilter.valueTooLarge" }) }];
    }
    return DEFAULT_ITEMS.filter(function (item) { return item.label.toLowerCase().includes(value.toString()); });
};
exports.sanitizeCustomInput = function (input) {
    return input && matchNumericValues(input) && Number(input) > 0 && Number(input) <= MAX_VALUE;
};
exports.sanitizeInput = function (input, intl) {
    if (!input) {
        return DEFAULT_ITEMS;
    }
    var trimmedInput = trimInput(input);
    var numericMatch = matchNumericValues(trimmedInput);
    if (numericMatch) {
        var numericText = numericMatch[1];
        var numericValue = Number.parseInt(numericText, 10);
        return sanitizeNumericValue(numericValue, intl);
    }
    return [{ type: "error", label: intl.formatMessage({ id: "rankingFilter.valueTooSmall" }) }];
};
//# sourceMappingURL=utils.js.map